import { Controller } from "@hotwired/stimulus";

// Safari-compatible image viewer controller
export default class extends Controller {
  static targets = ["image"];

  connect() {
    // Add click handler for better Safari compatibility
    this.imageTarget.addEventListener("click", this.open.bind(this));
  }

  disconnect() {
    // Clean up event listener
    if (this.imageTarget) {
      this.imageTarget.removeEventListener("click", this.open.bind(this));
    }
  }

  open(event) {
    event.preventDefault();

    // Check if we're on Safari
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (isSafari) {
      // For Safari, open in new window/tab
      const imageUrl = this.imageTarget.src;
      const newWindow = window.open(
        imageUrl,
        "_blank",
        "width=800,height=600,scrollbars=yes,resizable=yes"
      );

      if (!newWindow) {
        // Fallback if popup is blocked
        window.location.href = imageUrl;
      }
    } else {
      // For other browsers, try to use ViewerJS if available
      try {
        if (typeof Viewer !== "undefined") {
          const viewer = new Viewer(this.imageTarget);
          viewer.show();
        } else {
          // Fallback to new window
          window.open(this.imageTarget.src, "_blank");
        }
      } catch (error) {
        console.warn("ViewerJS not available, falling back to new window");
        window.open(this.imageTarget.src, "_blank");
      }
    }
  }
}
